<template>
  <div class="how_sect">
    <h2>{{ $_translations.value[title] }}</h2>

    <p>
      {{ $_translations.value[description] }}
    </p>
  </div>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    default: '',
  },
  description: {
    type: String,
    default: '',
  },
});
</script>
